import { useState } from 'react';
import { api } from '../api';
import { ErrorMsg, Modal } from './Modal';

export function WorkspaceForm(props: {
  initial?: { id: number; name: string; description: string | null; privacy: string; color: string | null };
  onClose: () => void; onSaved: () => void;
}) {
  const [name, setName] = useState(props.initial?.name ?? '');
  const [description, setDescription] = useState(props.initial?.description ?? '');
  const [privacy, setPrivacy] = useState(props.initial?.privacy ?? 'Private');
  const [color, setColor] = useState(props.initial?.color ?? '#00a651');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function save() {
    setBusy(true);
    setError(null);
    try {
      const body = { name, description: description || null, privacy, color };
      if (props.initial) await api.put(`/workspaces/${props.initial.id}`, body);
      else await api.post('/workspaces', body);
      props.onSaved();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal title={props.initial ? 'Setări workspace' : 'Workspace nou'} onClose={props.onClose}>
      <label>Nume<input value={name} onChange={(e) => setName(e.target.value)} autoFocus /></label>
      <label>Descriere<textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} /></label>
      <label>Vizibilitate
        <select value={privacy} onChange={(e) => setPrivacy(e.target.value)}>
          <option value="Private">Privat — doar membrii</option>
          <option value="Closed">Închis — vizibil tuturor, conținut doar pentru membri</option>
          <option value="Open">Deschis — toți din firmă pot vedea</option>
        </select>
      </label>
      <label>Culoare<input type="color" value={color} onChange={(e) => setColor(e.target.value)} /></label>
      <ErrorMsg error={error} />
      <div className="actions">
        <button onClick={props.onClose}>Renunță</button>
        <button className="primary" disabled={busy || name.trim().length < 2} onClick={save}>Salvează</button>
      </div>
    </Modal>
  );
}
